import { render } from "./Multi-Select.vue?vue&type=template&id=6255755e"
import script from "./Multi-Select.vue?vue&type=script&lang=js"
export * from "./Multi-Select.vue?vue&type=script&lang=js"

import "./Multi-Select.vue?vue&type=style&index=0&id=6255755e&lang=css"

import exportComponent from "C:\\Users\\User\\OneDrive\\工作案件\\前端管理介面\\vue3-adminlte3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__